<template>
	<div class="storeinfo">
		<van-nav-bar :title="title" fixed left-arrow @click-left="onClickLeft">
		  <template #left>
				<img src="../../../assets/img/icon/left-arrow.png" class="icon" />
		  </template>
		</van-nav-bar>
		
		<div  class="collapse">
			<van-cell-group>
				<van-field
					v-model.trim="params.s_name"
					label="店铺名称："
					placeholder="请输入店铺名称"
					required
					clearable
					v-if="(params.s_stauts==0||params.s_stauts==2)"
				></van-field>
				<van-cell v-else
					title="店铺名称："
					:value="params.s_name"
				></van-cell>

				<van-cell
					@click="showPickers(1)"
					title="经营行业："
					is-link
					v-if="params.s_stauts==0||params.s_stauts==2"
					required
					:value="params.s_category"
					title-class="van-cell-title"
				></van-cell>
				<van-cell
					title="经营行业："
					:is-link="false"
					v-else
					:value="params.s_category"
					title-class="van-cell-title"
				></van-cell>

				<van-cell
					@click="showPickers(2)"
					title="经营类型："
					required
					is-link
					:value="params.s_type"
					title-class="van-cell-title"
					v-if="params.s_stauts==0||params.s_stauts==2"
				></van-cell>
				<van-cell
					title="经营类型："
					:is-link="false"
					v-else
					:value="params.s_type"
					title-class="van-cell-title"
				></van-cell>

				<van-cell
					title="营业执照："
					:required="params.s_stauts==0||params.s_stauts==2"
					title-class="van-cell-title">
					<van-uploader max-count="1" v-model="licenseList" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadIicense" :before-read="beforeRead" v-if="params.s_stauts==0||params.s_stauts==2"/>
					<van-image :src="licenseList.length?licenseList[0].url:''" width="100px" @click="onImagePreview(licenseList.length?licenseList[0].url:'')"></van-image>
				</van-cell>

				<van-cell
					title="门面主图："
					required
					title-class="van-cell-title">
				<van-uploader max-count="1" v-model="imgList" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadImg" :before-read="beforeRead" />
				</van-cell>
				<van-cell
					@click="showPickers(3)"
					title="所在地区："
					required
					is-link
					:value="params.s_location"
					title-class="van-cell-title"
				></van-cell>
				<van-field
					v-model.trim="params.s_address"
					label="街道地址："
					required
					placeholder="请输入详细地址"
					clearable
				@blur="locationAmapByAddress(params.s_address)"
				></van-field>
				<van-field
					v-model.trim="params.s_charger"
					label="负责人："
					required
					placeholder="请输入负责人"
					clearable
				></van-field>
				<van-field
					v-model.trim="params.s_telphone"
					type="tel"
					label="联系电话："
					required
					placeholder="请输入联系电话"
					clearable
				></van-field>

				<div id="amap_container_store" class="amap_container"></div>

				<van-field
				  v-model.trim="params.s_summary"
				  rows="2"
				  autosize
				  label="店铺简介："
				  type="textarea"
				  maxlength="150"
				  placeholder="请输入简介内容..."
				  show-word-limit
				/>
				
				<van-cell v-if="params.s_stauts==0||params.s_stauts==2">
					<van-checkbox v-model="agreement">同意「<span @click.stop="showAgreementJoin" style="color:blue;">入驻协议</span>」条款！</van-checkbox>
				</van-cell>
				
			</van-cell-group>

			<van-cell-group style="padding: 30px 10px;">
				<van-button type="primary" block @click="onSaveStore()" style="margin:0px auto;" v-if="params.s_stauts!=99">保存</van-button>
			</van-cell-group>

		</div>

		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="pickerColumns"
			@cancel="showPicker = false"
			@confirm="onPickerConfirm"
		  />
		</van-popup>

		<van-popup v-model="agreementPopup" position="bottom" :style="{'height':'80%'}">
			<div class="agreement_title">{{agreementJoin.title||'入驻协议'}}</div>
			<div class="agreement_content" v-html="agreementJoin.content||'暂无协议内容！'"></div>
		</van-popup>
	</div>
</template>

<script>
import { chkImgType } from "@/utils/common.js";
import { ImagePreview } from 'vant';
export default {
	name: "StoreInfo",
	data() {
		return {
			title: "店铺信息",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			showPicker:false,
			pickerType:-1,
			pickerColumns:[],

			areaColumns:JSON.parse(localStorage.getItem("area_districts")),
			value: "",
			attach_url: this.Conf.serverPre,
			params:{s_stauts:0,s_summary:''},
			preAddress:'',
			amap:{},
			amapGeocoder:{},
			amapMarker:false,
			licenseList:[],
			imgList:[],
			imgSizeLimit:500 * 1024,
			agreement:false,
			agreementPopup:false,
			agreementJoin:{}
		};
	  },
	  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		// 返回
		onClickLeft() {
			this.$router.go(-1);
		},
		showPickers(t){
			if(t==2 && !this.params.s_category){
				this.$toast.fail("请先选择经营行业");
				return false;
			}
			this.pickerType = t;
			switch(t){
				case 1:
					this.pickerColumns = this.Conf.industryCategory
				break;
				case 2:
					this.pickerColumns = this.Conf.industryTypes[this.Conf.industryCategory.indexOf(this.params.s_category)];
				break;
				case 3:
					this.pickerColumns = this.areaColumns
				break;
				default:
				break;
			}
			this.showPicker = true;
		},
		onPickerConfirm(value, index){
			switch(this.pickerType){
				case 1:
					this.params.s_category = value;
					this.params.s_type = "";
				break;
				case 2:
					this.params.s_type = value[1];
				break;
				case 3:
					this.onAreaConfirm(value, index);
				break;
				default:
				break;
			}
			this.showPicker = false;
		},
		onAreaConfirm(value, index) {
			this.params['s_location'] = value.join("")
			this.initAmapByCity(value.join(""))
		},
		initAmapByCity(cityad){
			this.amapGeocoder = new AMap.Geocoder({
				city:''
			});
			this.locationAmapByAddress(cityad)
		},
		markerAmap(lnglat,reset){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
			this.params['s_lng'] = lnglat[0];
			this.params['s_lat'] = lnglat[1];
			if(reset){
				this.resetAddressByLnglat(lnglat);
			}
		},
		resetAddressByLnglat(lnglat){
			var geocoder = new AMap.Geocoder({
				city: ''
			})
			let that = this;
			geocoder.getAddress(lnglat, function (status, data) {
				if (status === 'complete' && data.info === 'OK') {
					// result为对应的地理位置详细信息
					//console.log(data)
					let faddress = data.regeocode.formattedAddress;
					let acomp = data.regeocode.addressComponent;
					let district = acomp.district;
					if(!(that.params.s_location && that.params.s_location.indexOf(district) > -1)){
						that.params.area = acomp.province+acomp.city+district;
					}
					let fadr = faddress.split(district);
					that.$delete(fadr, 0);
					that.params.s_address = fadr.join(district);
					that.$forceUpdate();
				}
			})

		},
		locationAmapByAddress(ads){
			if(ads && ads != this.preAddress){
				let that = this;
				this.amapGeocoder.getLocation(ads, function(status, result) {
					if (status === 'complete'&&result.geocodes.length) {
						let local = result.geocodes[0].location;
						that.markerAmap([local.lng, local.lat],0);
					}else{
						that.$toast.fail("地址定位失败，请手动指定");
					}
				});
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		afterReadIicense(file){
			this.params['s_license'] = file.content
			this.licenseList = [{url:file.content, isImage: true}];
		},
		afterReadImg(file){
			this.params['s_img'] = file.content
			this.imgList = [{url:file.content, isImage: true}];
		},
		onSaveStore(){
			if(!this.params['s_name']){
				this.$toast.fail("请输入店铺名称！");
				return false;
			}
			if(!this.params['s_category']){
				this.$toast.fail("请选择经营行业！");
				return false;
			}
			if(!this.params['s_type']){
				this.$toast.fail("请选择经营类型！");
				return false;
			}
			if(!this.params['s_license']){
				this.$toast.fail("请上传营业执照！");
				return false;
			}
			if(!this.params['s_img']){
				this.$toast.fail("请上传门面主图！");
				return false;
			}
			if(!this.params['s_location']){
				this.$toast.fail("请选择所在地区！");
				return false;
			}
			if(!this.params['s_address']){
				this.$toast.fail("请填写街道地址！");
				return false;
			}
			if(!this.params['s_lng'] || !this.params['s_lat']){
				this.$toast.fail("请在地图上标记店铺位置！");
				return false;
			}
			if((this.params.s_stauts==0||this.params.s_stauts==2) && !this.agreement){
				this.$toast.fail("请先同意「入驻协议」条款！");
				return false;
			}
			this.params['u_id'] = this.u_id;
			this.params['token'] = this.token;
			
			var formData = new window.FormData();
			for(var c in this.params){
				formData.append(c,this.params[c]);
			}
			var url = this.Conf.serverUrl + "UserStore/saveStore" + "?num=" + Math.random();
			let that = this;
			that.$axios
			.post(url, formData, { "Content-Type": "multipart/form-data" })
			.then(response => {
				if (response.data.msg) {
					that.$toast.success(response.data.msg);
				}
				if(response.data.code == 200){
					that.$router.push({ path: "/StoreManage" });
				}
			})
			.catch(error => {});

		},
		showAgreementJoin(){
			this.agreementPopup=true;
			if(!this.agreementJoin.id){
				var url = this.Conf.serverUrl + "Common/docx" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify({code:'agreement_join'}))
				.then(response => {
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
						return false
					}
					if(response.data.data){
						this.agreementJoin = response.data.data;
					}
				})
				.catch(error => {});
			}
		},
		onImagePreview(url){
			ImagePreview([url])
		}
	},
	created() {
		if (!this.u_id) {
			this.$router.push({ path: "/login" });
		}
		this.getStateConfigs();
		if(this.$route.query.s_id){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id: this.$route.query.s_id
			};
			var url = this.Conf.serverUrl + "UserStore/storeInfo" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 40001){
					this.$toast.fail(response.data.msg);
					this.onClickLeft();
					return false
				}
				if(response.data.store){
					this.params = response.data.store;
					this.preAddress = this.params.s_address;
					this.title = this.params.s_name;
					this.licenseList = [{url:this.attach_url+this.params.s_license}];
					this.imgList = [{url:this.attach_url+this.params.s_img}];
					this.markerAmap([this.params.s_lng, this.params.s_lat],0);
				}
			})
			.catch(error => {});
		}
		let that = this;
		this.$nextTick(() => {
			that.amap = new AMap.Map("amap_container_store", {
				resizeEnable: true
			});
			that.amap.on('click', function(e) {
				that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()],1);
			});
		});
	}
};
</script>





// WEBPACK FOOTER //
// src/components/My/Store/StoreInfo.vue